import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { EEntityType, IEntity, IError } from '@unfoldrtech/portal-mic'
import { coreAPI } from '../services/coreAPI'

import { generateCorrelationId } from '../utils/helpers'

type TUpdateEntityStatusMutationResult = UseMutationResult<
  AxiosResponse<void>,
  AxiosError<IError>,
  { id: number; entityType: EEntityType; entity: IEntity }
>

export default function useUpdateEntityStatus({
  advertiserId,
  retailerId,
}: {
  advertiserId: number
  retailerId: number
}) {
  return useMutation(
    [`updateEntityStatus`],
    (params: { id: number; entityType: EEntityType; entity: IEntity }) =>
      coreAPI.v2AdvertiserCampaigns().updateEntityStatus(
        advertiserId,
        params.entityType,
        retailerId,
        params.id,
        generateCorrelationId(),
        // @ts-expect-error: fix in PORT-2535
        params.entity
      )
  ) as TUpdateEntityStatusMutationResult
}
